import * as storage from './storage';
export const pulseStorageKeys = {
    PULSE_PPID_STORAGE_KEY: '_pulse.internal.identity.ppid',
    PULSE_CIS_CACHE_STORAGE_KEY: '_pulse.internal.identity.cis',
};
const getPPIDsFromStorage = () => {
    try {
        const webStorage = storage.getStorage();
        return JSON.parse(webStorage.getItem(pulseStorageKeys.PULSE_PPID_STORAGE_KEY) ?? '{}');
    }
    catch (_err) {
        return {};
    }
};
const setPPIDsToStorage = (ppid) => {
    try {
        const webStorage = storage.getStorage();
        /**
         * we maintain the interface consistent with the ppId api, but there is no need to persist an empty object in
         * localStorage. We normalise back when we read the value.
         * @see getPPIDsFromStorage
         */
        if (Object.keys(ppid).length === 0) {
            webStorage.removeItem(pulseStorageKeys.PULSE_PPID_STORAGE_KEY);
            return true;
        }
        webStorage.setItem(pulseStorageKeys.PULSE_PPID_STORAGE_KEY, JSON.stringify(ppid));
        return true;
    }
    catch (_err) {
        return false;
    }
};
const getCisCacheFromStorage = () => {
    try {
        const webStorage = storage.getStorage();
        return JSON.parse(webStorage.getItem(pulseStorageKeys.PULSE_CIS_CACHE_STORAGE_KEY) ?? '{}');
    }
    catch (_err) {
        return {};
    }
};
const setCisCacheToStorage = (cisPayload) => {
    try {
        const webStorage = storage.getStorage();
        webStorage.setItem(pulseStorageKeys.PULSE_CIS_CACHE_STORAGE_KEY, JSON.stringify(cisPayload));
        return true;
    }
    catch (_err) {
        return false;
    }
};
export default {
    getCisCacheFromStorage,
    setCisCacheToStorage,
    getPPIDsFromStorage,
    setPPIDsToStorage,
};
//# sourceMappingURL=pulseStorage.js.map